import cloneDeep from "lodash/cloneDeep"

export default ({ configTemplate: sourceConfigTemplate }) => {
    const configTemplate = cloneDeep(sourceConfigTemplate);

    let fields = {};
    const exploreConfig = ({ category, availableFieldList }) => {
        for (const field of availableFieldList) {
            const currentCategory = fields && fields[category] || [];

            if (field.FieldId) {
                const updatedCategory = [...currentCategory, { FieldId: field.FieldId, Type: field.Type }];
                fields = Object.assign({}, fields, { [category]: updatedCategory });
            }

            if (field.Options) {
                for (const f of field.Options) {

                    const currentCategory = fields && fields[category] || [];

                    if (f.FieldId) {
                        const updatedCategory = [...currentCategory, { FieldId: f.FieldId, Type: f.Type }];
                        fields = Object.assign({}, fields, { [category]: updatedCategory });
                    }

                    if (f.Type === 'object' && f.AvailableFieldList) {
                        exploreConfig({ category, availableFieldList: f.AvailableFieldList });
                    }
                    if (f.AvailableFieldList) {
                        exploreConfig({ category, availableFieldList: f.AvailableFieldList });
                    }
                }
            }
            if (field.AvailableFieldList) {
                exploreConfig({ category, availableFieldList: field.AvailableFieldList })
            }
        }
    }
    for (const [category, templateFields] of Object.entries(configTemplate)) {
        if (templateFields.AvailableFieldList) {
            exploreConfig({ category, availableFieldList: templateFields.AvailableFieldList });
        }
    }
    return fields;
}